import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { OwnershipTransferPrivateBuyerStep, PopupEnum, ServiceType } from '../Constant/Constant';
import { setCurrentStep, setShowPopUp, setCurrentPopUp, setSelectedPricePlan, validateTransferAccess } from '../OwnershipTransferBuyerSlice';
import SalePackages from '../../SalePackagesBlock/SalePackages';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'

const SelectPackage = (props) => {
    const [error, setError] = useState(false);
    const [errorText, setErrorText] = useState('');
    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
            dwhGeneralReport({
                data: { ...props.data, userDetails: props.userDetails },
                actionType: DwhActionType.ChoosePackagePage,
                messageText: DWHMessageText.ChoosePackagePageDisplayed,
                status: DWHStatus.Ongoing
            });
        }
    }, []);

    function onSelectPackage(selectedPackage) {
        props.setSelectedPricePlan(selectedPackage);
    }

    function nextStep() {
        if (!props.data.selectedPricePlan && !props.serviceForm.serviceFormIsSign) {
            setErrorText('כדי להמשיך יש לבחור חבילה ולאשר את התנאים');
            setError(true);
        } else if (!props.data.selectedPricePlan && props.serviceForm.serviceFormIsSign) {
            setErrorText('כדי להמשיך יש לבחור חבילה');
            setError(true);
        } else if (props.data.selectedPricePlan && !props.serviceForm.serviceFormIsSign) {
            setErrorText('כדי להמשיך יש לאשר את תנאי החבילה');
            setError(true);
        } else {
            dwhGeneralReport({
                data: { ...props.data, userDetails: props.userDetails },
                actionType: DwhActionType.ChoosePackagePage,
                messageText: DWHMessageText.ChooseBanPageButtonClicked,
                status: DWHStatus.Ongoing
            });

            if (props.data.serviceType == ServiceType.Cellular) {
                const serviceForm = [];

                Object.entries(props.serviceForm.serviceForm).forEach(([key, value]) => {
                    const itemData = {
                        name: key,
                        configuredvalue: value === true ? 'Y' : 'N'
                    }
                    serviceForm.push(itemData);
                });
                const validationRequest = {
                    ServiceForm: serviceForm,
                    OfferId: props.data.selectedPricePlan.offerID,
                }
                props.validateTransferAccess(validationRequest)
            }


        }

    }
    return (
        <div className='ownership-transfer-select-package'>
            <div className='l-title'>עם איזו חבילה נתקדם?</div>
            <SalePackages
                packages={props.iContent.packagesList}
                onSelectedPackages={(newPackage) => onSelectPackage(newPackage)}
                oneTimeFee={false}
                isChangePricePlan={false}
                setBorder={true}
            />
            <div className='service-form-link'>
                <a onClick={() => props.setCurrentPopUp({ currentPopUp: PopupEnum.ServiceFormPopup })}>
                    <Image src={props.serviceForm.serviceFormIsSign ? require('../Icons/check.svg') : require('../Icons/services-form-icon.svg')} />
                    <div className='link-text'>לחצו כאן לחתימה על גישה לשירותים </div>
                </a>
            </div>
            <div className='continue-button'>
                {error && <div className='error center'>{errorText}</div>}
                <BtnSubmit onclick={nextStep} text={'בחרתי, אפשר להמשיך'} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    data: state.OwnershipTransferPrivateBuyer,
    serviceForm: state.serviceAccessForm,
    userDetails: state.authentication?.loginData,

});

const mapDispatchToProps = {
    setShowPopUp,
    setCurrentStep,
    setCurrentPopUp,
    setSelectedPricePlan,
    validateTransferAccess
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectPackage);
